import Nav from './components/nav';
import News from './components/news';
import Video from './components/video';
import Home from './controllers/home';
import Page from './controllers/page';
import ArchiveVideos from './controllers/archive-videos';
import Faq from './controllers/archive-faq';
import Cse from './controllers/archive-cse';
import Blog from './controllers/blog';
import ConventionsContrats from './controllers/conventions-contrats';
import GardesAstreintes from './controllers/gardes-astreintes';
import BourseEmploi from './controllers/bourse-emploi';
import Search from './controllers/search';
import Equipe from './controllers/equipe';
import Trombinoscope from './controllers/archive-trombinoscope';
import Self from './controllers/self';
import TemplateGalerie from './controllers/template-galerie';

document.addEventListener('DOMContentLoaded', () => {
  new Nav();
  new News();
  new Video();

  switch (true) {
    case document.body.classList.contains('home'):
      new Home();
      break;

    case document.body.classList.contains('post-type-archive-videos'):
      new ArchiveVideos();
      break;

    case document.body.classList.contains('tax-videos_tag'):
      new ArchiveVideos();
      break;

    case document.body.classList.contains('tax-categorie'):
      new Faq();
      break;

    case document.body.classList.contains('blog'):
      new Blog();
      break;

    case document.body.classList.contains('tag'):
      new Blog();
      break;

    case document.body.classList.contains('tax-categorie-offres-partenaires'):
      new Cse();
      break;

    case document.body.classList.contains('page-template-conventions-contrats'):
      new ConventionsContrats();
      break;

    case document.body.classList.contains('page-template-gardes-astreintes'):
      new GardesAstreintes();
      break;

    case document.body.classList.contains('page-template-bourse-emploi'):
      new BourseEmploi();
      break;

    case document.body.classList.contains('post-type-archive-equipe'):
      new Equipe();
      break;

    case document.body.classList.contains('search-results'):
      new Search();
      break;

    case document.body.classList.contains('tax-categorie-trombinoscope'):
      new Trombinoscope();
      break;

    case document.body.classList.contains('single-menus'):
    case document.body.classList.contains('post-type-archive-menus'):
      new Self();
      break;
    
    case document.body.classList.contains('page-template-galerie'):
      new TemplateGalerie();
      break;

    default:
      new Page();
  }
});